import CompanyList from '@/components/company/CompanyList'
import CompanyCreate from '@/components/company/CompanyCreate'
import CompanyVue from '@/components/company/CompanyVue'
import CompanyEdit from '@/components/company/CompanyEdit'

export default [
  {
    path: '/societes',
    name: 'CompanyList',
    component: CompanyList,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      needProfile: ['admin', 'sector_manager']
    }
  },
  {
    path: '/societes/creation',
    name: 'CompanyCreate',
    component: CompanyCreate,
    meta: {
      parentName: 'CompanyList',
      requiresAuth: true,
      needProfile: ['admin']
    }
  },
  {
    path: '/societes/:id/edition',
    name: 'CompanyEdit',
    component: CompanyEdit,
    meta: {
      parentName: 'CompanyVue',
      requiresAuth: true,
      needProfile: ['admin']
    }
  },
  {
    path: '/societes/:id',
    name: 'CompanyVue',
    component: CompanyVue,
    meta: {
      parentName: 'CompanyList',
      requiresAuth: true,
      needProfile: ['admin', 'manager_ext', 'sector_manager']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/companyRouter.js